__turbopack_context__.v({
  "actionButton": "WdAX5a_actionButton",
  "actions": "WdAX5a_actions",
  "body": "WdAX5a_body",
  "content": "WdAX5a_content",
  "preview": "WdAX5a_preview",
});
